var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhantom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3758 19.7513C9.88781 22.0682 7.39439 25.0001 4.07655 25.0001C2.50812 25.0001 1 24.344 1 21.494C1 14.2359 10.7525 3.00012 19.8011 3.00012C24.9489 3.00012 27 6.6292 27 10.7503C27 16.0402 23.6217 22.0886 20.2636 22.0886C19.1979 22.0886 18.6751 21.494 18.6751 20.5509C18.6751 20.3049 18.7153 20.0383 18.7957 19.7513C17.6496 21.7401 15.4377 23.5854 13.3665 23.5854C11.8584 23.5854 11.0943 22.6217 11.0943 21.2685C11.0943 20.7764 11.1949 20.2639 11.3758 19.7513ZM19.1704 10.6074C19.1704 11.8083 18.4732 12.4087 17.6932 12.4087C16.9014 12.4087 16.2159 11.8083 16.2159 10.6074C16.2159 9.40651 16.9014 8.80607 17.6932 8.80607C18.4732 8.80607 19.1704 9.40651 19.1704 10.6074ZM23.6018 10.6075C23.6018 11.8083 22.9045 12.4088 22.1246 12.4088C21.3327 12.4088 20.6473 11.8083 20.6473 10.6075C20.6473 9.40661 21.3327 8.80617 22.1246 8.80617C22.9045 8.80617 23.6018 9.40661 23.6018 10.6075Z",
    fill: "#8047FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhantom);
export default __webpack_public_path__ + "static/media/phantom.968898061ff275239ede7ee839768ac0.svg";
export { ForwardRef as ReactComponent };